import { Routes } from '@angular/router';

import { ErrorComponent } from './error.component';

/** Route definition for the error page. */
export default [
  {
    path: '',
    component: ErrorComponent,
  },
] as Routes;
